import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  user: null,
  token: null,
  showDialog: false,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setCredentials: (state, action) => {
      
      state.user = action.payload.user;
      state.token = action.payload.token;
    },
    logout: (state) => {
      
      state.token = null;
      state.user = null;
      // sessionStorage.removeItem("token");
    },
    showDialog: (state, action) => {
      state.showDialog = action.payload;
    },
  },
});

export const { setCredentials, logout, showDialog } = authSlice.actions;

export default authSlice.reducer;
